<div class="dashboard-pagina">
  <div class="cabecalho">
    <h2>Dashboard</h2>

    @if (!mobile && !carregando && !erroCarregamento) {
      <div class="acoes">
        @if (modoEdicao) {
          <p-button label="Adicionar widget" icon="pi pi-plus" [outlined]="true" (onClick)="iniciarAdicao(null)" />
          <p-button label="Cancelar" icon="pi pi-times" [text]="true" [disabled]="salvando" (onClick)="cancelar()" />
          <p-button label="Salvar" icon="pi pi-check" [loading]="salvando" (onClick)="salvar()" />
        } @else if (itens.length) {
          <p-button icon="pi pi-cog" [rounded]="true" [text]="true" severity="secondary" ariaLabel="Editar dashboard"
            pTooltip="Editar dashboard" tooltipPosition="left" styleClass="botao-editar" (onClick)="editar()" />
        }
      </div>
    }
  </div>

  @if (alteradoEmOutroLugar) {
    <div class="aviso" role="alert">
      <i class="pi pi-exclamation-triangle"></i>
      <span>O dashboard foi alterado em outro lugar. Recarregue para continuar.</span>
      <p-button label="Recarregar" icon="pi pi-refresh" size="small" [text]="true" (onClick)="carregar()" />
    </div>
  }

  @if (erros.length) {
    <div class="painel-erros" role="alert">
      <strong><i class="pi pi-times-circle"></i> O layout não foi salvo:</strong>
      <ul>
        @for (erro of erros; track $index) {
          <li>{{ erro }}</li>
        }
      </ul>
    </div>
  }

  @if (carregando) {
    <div class="estado"><p-progressSpinner styleClass="w-3rem h-3rem" strokeWidth="4" /></div>
  } @else if (erroCarregamento) {
    <div class="estado card">
      <i class="pi pi-exclamation-circle"></i>
      <span>Não foi possível carregar o dashboard.</span>
      <p-button label="Tentar novamente" [text]="true" (onClick)="carregar()" />
    </div>
  } @else if (!itens.length && !modoEdicao) {
    <div class="estado card">
      <i class="pi pi-th-large"></i>
      <span>Seu dashboard está vazio</span>
      @if (!mobile) {
        <p-button label="Adicionar widget" icon="pi pi-plus" (onClick)="iniciarAdicao(null)" />
      }
    </div>
  } @else {
    <div class="dashboard-container">
      <div #grade class="dashboard" [class.mobile]="mobile" [class.edicao]="edicaoAtiva" [style.grid-template-rows]="linhasDaGrade">
        @for (item of itensExibidos; track item.chave) {
          <lx-widget-host [item]="item" [modoEdicao]="edicaoAtiva" [mobile]="mobile"
            [class.alt2]="item.altura === 2" [class.arrastando]="arraste?.item === item"
            [style.grid-column]="mobile ? null : (item.coluna + 1) + ' / span ' + item.largura"
            [style.grid-row]="mobile ? null : (item.linha + 1) + ' / span ' + item.altura"
            (configChange)="aoAlterarConfig(item, $event)" (remover)="remover(item)" (arrastar)="iniciarArraste(item, $event)" />
        }

        @for (slot of slots; track slot.linha + ':' + slot.coluna) {
          <button type="button" class="slot" [style.grid-column]="slot.coluna + 1" [style.grid-row]="slot.linha + 1"
            [attr.data-slot]="slot.linha + ':' + slot.coluna"
            [attr.aria-label]="'Adicionar widget na linha ' + (slot.linha + 1) + ', coluna ' + (slot.coluna + 1)"
            (click)="iniciarAdicao(slot)">
            <i class="pi pi-plus"></i>
          </button>
        }

        @if (arraste?.destino; as destino) {
          <div class="destino" [class.valido]="arraste!.valido"
            [style.grid-column]="(destino.coluna + 1) + ' / span ' + arraste!.item.largura"
            [style.grid-row]="(destino.linha + 1) + ' / span ' + arraste!.item.altura"></div>
        }
      </div>
    </div>
  }
</div>

@if (arraste) {
  <div class="fantasma" [style.left.px]="arraste.x + 12" [style.top.px]="arraste.y + 12">
    <i [ngClass]="arraste.item.icone || 'pi pi-th-large'"></i>
    {{ arraste.item.nome }}
  </div>
}

<app-adicionar-widget [(visivel)]="modalVisivel" [itens]="itens" [slot]="slotModal" (escolher)="adicionar($event)" />
